import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin } from '../config/api'; // Import real API login function
import {signup as apiSignup} from '../config/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('authToken');
    const userData = localStorage.getItem('userData_30jan');
    
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    
    setLoading(false);
  }, []);

  const login = async (credentials) => {
    try {
      
      const response = await apiLogin(credentials);
      
      // Assuming API returns: { success: true, user: {...}, token: "..." }
      if (response.success) {
        localStorage.setItem('authToken', response.token);
        localStorage.setItem('userData_30jan', JSON.stringify(response.user));
        
        setIsAuthenticated(true);
        setUser(response.user);
        
        return response;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw new Error('Login failed: ' + error.message);
    }
  };

  const signup = async (credentials) => {
    try {
      
      const response = await apiSignup(credentials);
      
      if (response.success) {
        // localStorage.setItem('authToken', response.token);
        // localStorage.setItem('userData', JSON.stringify(response.user));
        
        setIsAuthenticated(false);
        // setUser(response.user);
        
        return response;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw new Error('Signup failed: ' + error.message);
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData_30jan');
    setIsAuthenticated(false);
    setUser(null);
  };

  const getUserRole = () => {
    const userData = JSON.parse(localStorage.getItem('userData_30jan') || '{}');
    return userData.role;
  };

  const value = {
    isAuthenticated,
    user,
    login,
    signup,
    logout,
    loading,
    getUserRole,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};